import { memo } from 'react';
import { Typography } from '../../../../../components/typography/typography';
import { EditableField } from '../../../../../components/field/field';
import classNames from 'classnames';
import styles from './product-item.module.css';
import { toast } from '../../../../../util/toasts';
import { ProductItemDataReturn, ProductItemState } from '../../hooks/use-product-item-data';
import deepEqual from 'deep-equal';

interface ProductItemDiscountProps extends Pick<ProductItemState, 'isEditing' | 'isCustomProduct' | 'discount'> {
  updateInputItem: ProductItemDataReturn['updateInputItem'];
}

export const ProductItemDiscount = memo<ProductItemDiscountProps>(
  ({ isEditing, isCustomProduct, discount, updateInputItem }) => {
    if (isCustomProduct) {
      return (
        <Typography
          type="text-sm"
          weight="regular"
          className={classNames(styles.fieldContentText)}
          dataCy="product-item-discount-na"
        >
          N/A
        </Typography>
      );
    }

    if (isEditing) {
      return (
        <div className="whitespace-nowrap">
          <EditableField
            type="number"
            label="Discount"
            value={discount.current}
            formattedValue={`${discount.current} %`}
            canReset={discount.canReset}
            resetPosition="right"
            onReset={() => updateInputItem({ manualDiscount: discount.original })}
            onChange={(value) => {
              if (value < 0 || value > 100) {
                toast('Discount must be between 0% and 100%', 'error');
                return;
              }
              updateInputItem({ manualDiscount: value });
            }}
          />
        </div>
      );
    }

    return (
      <Typography
        type="text-sm"
        weight="regular"
        className={classNames(styles.fieldContentText)}
        dataCy="product-item-discount-value"
      >
        {`${discount.current} %`}
      </Typography>
    );
  },
  (prevProps, nextProps) => {
    return prevProps.isEditing === nextProps.isEditing && deepEqual(prevProps.discount, nextProps.discount);
  },
);

ProductItemDiscount.displayName = 'ProductItemDiscount';
